import { render, staticRenderFns } from "./PayerUpdateAction.vue?vue&type=template&id=5fe96aea&scoped=true"
import script from "./PayerUpdateAction.vue?vue&type=script&lang=js"
export * from "./PayerUpdateAction.vue?vue&type=script&lang=js"
import style0 from "./PayerUpdateAction.vue?vue&type=style&index=0&id=5fe96aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe96aea",
  null
  
)

export default component.exports